import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            Preguntas frecuentes
          </h2>
          <p className="text-xl text-gray-600">
            Resuelvo las dudas más comunes
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="bg-white border-2 border-gray-100 rounded-xl px-6 hover:border-[#00E5A3] transition-colors"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-[#013139] hover:text-[#00E5A3] py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional CTA */}
          <div className="mt-12 text-center p-8 bg-gradient-to-r from-[#013139] to-[#024F5B] rounded-2xl">
            <h3 className="text-2xl font-bold text-white mb-4">
              ¿Tienes más preguntas?
            </h3>
            <p className="text-gray-200 mb-6">
              Hablemos en una llamada gratuita de 30 minutos
            </p>
            <button
              onClick={() => {
                const subject = encodeURIComponent('Solicitud de llamada gratuita - FluenceIA');
                const body = encodeURIComponent(`Hola Emilio,

Me gustaría reservar una llamada gratuita de 30 minutos para conocer cómo puedes ayudarme a automatizar mi negocio con IA.

Mis datos:
- Nombre: 
- Tipo de negocio: 
- Teléfono: 

Horarios que me vienen bien:
- Opción 1: 
- Opción 2: 
- Opción 3: 

Gracias,
`);
                window.location.href = `mailto:esaezye@gmail.com?subject=${subject}&body=${body}`;
              }}
              className="bg-[#00E5A3] hover:bg-[#00C497] text-[#013139] font-bold px-8 py-3 rounded-lg transition-colors"
            >
              Reserva tu llamada
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
